/* eslint-disable guard-for-in */
const validate = values => {
    const errors = {};
    if (values.feeConfigList) {
        const feeConfigListErrors = {};

        for (const prop in values.feeConfigList) {
            const propErrors = [];
            // eslint-disable-next-line complexity
            // eslint-disable-next-line no-loop-func
            values.feeConfigList[prop].forEach((bank, bankIndex) => {
                const bankErrors = {};
                bankErrors.bankSlabs = [];

                if (prop === 'Net-Banking') {
                    if (!bank.issuerId || bank.issuerId === '') {
                        bankErrors.issuerId = 'Please select a bank';
                    }
                } else {
                    if (!bank.cardType || bank.cardType === '') {
                        bankErrors.cardType = 'Please select a scheme';
                    }
                }

                // eslint-disable-next-line complexity, no-unused-expressions
                bank.bankSlabs?.forEach((slab, slabIndex) => {
                    const slabErrors = {};

                    if (slab.feePercent === null || slab.feePercent === '') {
                        slabErrors.feePercent = 'Percent is required';
                    }
                    if (
                        slab.feePercent &&
                        !/^[0-9]+([,.][0-9]{1,4})?$/g.test(slab.feePercent)
                    ) {
                        slabErrors.feePercent =
                            'Please enter a valid number upto 4 decimals';
                    }
                    if (
                        slab.feePercent &&
                        (slab.feePercent < 0 || slab.feePercent > 100)
                    ) {
                        slabErrors.feePercent =
                            'Please enter a value b/w 0 and 100';
                    }
                    if (slab.feeFlat === null || slab.feeFlat === '') {
                        slabErrors.feeFlat = 'Flat is required';
                    }
                    if (
                        slab.feeFlat &&
                        !/^[0-9]+([,.][0-9]{1,2})?$/g.test(slab.feeFlat)
                    ) {
                        slabErrors.feeFlat =
                            'Please enter a valid number upto 2 decimals';
                    }
                    if (
                        slab.feeFlat &&
                        slab.upperSlab &&
                        slab.feeFlat > slab.upperSlab
                    ) {
                        slabErrors.feeFlat = 'Cannot be more than upper slab';
                    }
                    if (slab.tax === null || slab.tax === '') {
                        slabErrors.tax = 'Tax is required';
                    }
                    if (
                        slab.tax &&
                        !/^[0-9]+([,.][0-9]{1,2})?$/g.test(slab.tax)
                    ) {
                        slabErrors.tax =
                            'Please enter a valid number upto 2 decimals';
                    }
                    if (slab.tax && (slab.tax < 0 || slab.tax > 100)) {
                        slabErrors.tax = 'Please enter a value b/w 0 and 100';
                    }
                    if (slab.feeCriteria === null || slab.feeCriteria === '') {
                        slabErrors.feeCriteria = 'Criteria is required';
                    }

                    bankErrors.bankSlabs[slabIndex] = slabErrors;
                });

                propErrors[bankIndex] = bankErrors;
            });

            feeConfigListErrors[prop] = propErrors;
        }

        errors.feeConfigList = feeConfigListErrors;
    }

    return errors;
};

export default validate;
